import { WhmAvatar, WhmBox } from "@securitize/reactjs-whm";
import { useState } from "react";

export default function TokenAvatar({
  tokenIcon,
  issuerLogo,
  networkIcon,
}: {
  tokenIcon: string;
  issuerLogo: string;
  networkIcon: string;
}) {
  const [tokenIconError, setTokenIconError] = useState(false);
  return (
    <WhmBox
      sx={{ position: "relative", marginTop: "6px", marginBottom: "6px" }}
    >
      <WhmAvatar
        src={tokenIconError ? issuerLogo : tokenIcon}
        sx={{
          width: "32px",
          height: "32px",
          boxShadow: (theme) => `0 0 0 0.5px ${theme.palette.divider}`,
        }}
        onError={() => setTokenIconError(true)}
      />
      <WhmAvatar
        src={networkIcon}
        sx={{
          width: "18px",
          height: "18px",
          position: "absolute",
          top: "20px",
          left: "20px",
          // Opaque so the asset logo doesn't show through transparent network icons (e.g. Solana)
          bgcolor: "background.paper",
          border: (theme) => `1px solid ${theme.palette.background.paper}`,
        }}
      />
    </WhmBox>
  );
}
